import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _class, _descriptor, _descriptor2;
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { Expression } from "abreact/expression/Expression";
import { GuidedExpressionEditor } from "abreact/expression/ui/editor/GuidedExpressionEditor";
import { IfThenElseModel, OperandName } from "abreact/expression/ui/editor/impl/model/impl/conditional/IfThenElseModel";
import { OperatorOperandValueImpl } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/OperatorOperandValueImpl";
import { action, makeObservable, observable } from "mobx";
// import OperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.OperandValue;
// import OperatorOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.OperatorOperandValue;
import * as Immutable from "immutable";
// import ValidatedExpOperator = Expression.Domain.ValidatedExpOperator;

export let IfThenElseOperandValueModel = (_dec = observable.shallow, _dec2 = observable.ref, _class = class IfThenElseOperandValueModel {
  constructor(ifThenElseOperatorOperandValue, expressionDomainModel, parentModel) {
    _initializerDefineProperty(this, "operandValues", _descriptor, this);
    _initializerDefineProperty(this, "_parentModel", _descriptor2, this);
    _defineProperty(this, "id", void 0);
    _defineProperty(this, "_expOperator", void 0);
    _defineProperty(this, "_position", 0);
    _defineProperty(this, "_expressionDomainModel", void 0);
    this._parentModel = parentModel;
    this._expressionDomainModel = expressionDomainModel;
    this.init(ifThenElseOperatorOperandValue);
    makeObservable(this);
  }
  get position() {
    return this._position;
  }
  set position(value) {
    this._position = value;
  }
  init(ifThenElseOperatorOperandValue) {
    this.initOperandValueIfPresent(OperandName.IF, ifThenElseOperatorOperandValue);
    this.initOperandValueIfPresent(OperandName.THEN, ifThenElseOperatorOperandValue);
    this.initOperandValueIfPresent(OperandName.ELSE, ifThenElseOperatorOperandValue);
    this._expOperator = ifThenElseOperatorOperandValue.expOperator;
    this.id = ifThenElseOperatorOperandValue.id;
  }
  initOperandValueIfPresent(operandName, ifThenElseOperatorOperandValue) {
    let value = ifThenElseOperatorOperandValue.argumentOperandValuesByOperandName.get(operandName);
    if (value) {
      this.setOperandValue(operandName, value);
    }
  }
  get expOperator() {
    return this._expOperator;
  }
  static create(ifThenElseOperatorOperandValue, expressionDomainModel, parentModel) {
    return new IfThenElseOperandValueModel(ifThenElseOperatorOperandValue, expressionDomainModel, parentModel);
  }
  static createRootOperatorOperandValue(id, expOperator, operandName, expressionDomainModel) {
    let ifThenElseOperatorOperandValue = new OperatorOperandValueImpl({
      id: id,
      ...GuidedExpressionEditor.AbstractModel.AbstractRowModel.OperatorOperandValue.partialStateFromExpOperator(expOperator, expressionDomainModel)
    });
    return ifThenElseOperatorOperandValue.withOperandName(operandName);
  }
  static createEmpty(expOperator, id, expressionDomainModel, parentModel) {
    const operandNameToUse = parentModel != null ? OperandName.ELSE : OperandName.IF;
    return new IfThenElseOperandValueModel(IfThenElseOperandValueModel.createRootOperatorOperandValue(id, expOperator, operandNameToUse, expressionDomainModel), expressionDomainModel, parentModel);
  }
  get parentModel() {
    return this._parentModel;
  }
  get elseIsNextIf() {
    return OperatorOperandValueImpl.isInstance(this.elseOperandValue) && this.elseOperandValue.expOperator?.id === this._expOperator?.id;
  }
  get ifOperandValue() {
    return this.operandValues.get(OperandName.IF);
  }
  get thenOperandValue() {
    return this.operandValues.get(OperandName.THEN);
  }
  get elseOperandValue() {
    return this.operandValues.get(OperandName.ELSE);
  }
  get ifThenElseOperatorOperandValue() {
    const operandName = this.parentModel != null ? OperandName.ELSE : OperandName.IF;
    let operatorOperandValue = IfThenElseOperandValueModel.createRootOperatorOperandValue(this.id, this._expOperator, operandName, this._expressionDomainModel);
    let argumentOperandValuesByOperandName = Immutable.Map();
    if (this.ifOperandValue != null) {
      argumentOperandValuesByOperandName = argumentOperandValuesByOperandName.set(OperandName.IF, this.ifOperandValue);
    }
    if (this.thenOperandValue != null) {
      argumentOperandValuesByOperandName = argumentOperandValuesByOperandName.set(OperandName.THEN, this.thenOperandValue);
    }
    if (this.elseOperandValue != null) {
      argumentOperandValuesByOperandName = argumentOperandValuesByOperandName.set(OperandName.ELSE, this.elseOperandValue);
    }
    operatorOperandValue = operatorOperandValue.withArgumentOperandValuesByOperandName(argumentOperandValuesByOperandName);
    if (this.parentModel == null) {
      operatorOperandValue = operatorOperandValue.withExpAdditionalData({
        type: IfThenElseModel.ADDITIONAL_DATA_MARKING_TYPE,
        values: {}
      });
    }
    return operatorOperandValue;
  }
  setOperandValue(operandName, operandValue) {
    if (operandValue != null && operandName === "if") {
      operandValue = operandValue.withValueCategoryID(Expression.Domain.Constants.CATEGORY_SUB_EXPRESSION);
    }
    if (!operandValue) {
      this.operandValues.delete(operandName);
    } else {
      this.operandValues.set(operandName, operandValue);
    }
    return this;
  }
  updateParent() {
    if (this.parentModel) {
      this.parentModel.updateFromChild(this);
    }
  }
  updateFromChild(childModel) {
    this.setOperandValue(OperandName.ELSE, childModel.ifThenElseOperatorOperandValue);
    this.updateParent();
  }
  setParent(model) {
    this._parentModel = model;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "operandValues", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Map();
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_parentModel", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "init", [action], Object.getOwnPropertyDescriptor(_class.prototype, "init"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setOperandValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setOperandValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setParent", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setParent"), _class.prototype), _class);
//# sourceMappingURL=IfThenElseOperandValueModel.js.map
